import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import { DataTableColumnHeader } from "@/components/shared/data-table/data-table-column-header";
import { format } from "date-fns";
import { Category } from "../types";
import { useNavigate } from "react-router-dom";

export const columns: ColumnDef<Category>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    size: 10,
    maxSize: 10,
  },
  {
    accessorFn: (row) => row.category_profiles[0]?.name,
    id: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      return (
        <div className="flex space-x-2">
          <span className="max-w-[500px] truncate font-medium">
            {row.getValue("name")}
          </span>
        </div>
      );
    },
  },
  {
    accessorFn: (row) => row.product_containers.length,
    id: "products_count",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Products" />
    ),
    cell: ({ row }) => {
      const count = row.getValue("products_count") as number;
      const navigate = useNavigate();

      const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent row click event from firing
        const tagId = row.original.id;
        navigate(`/products?categories=${tagId}`);
      };

      return (
        <div className="flex w-[100px] items-center">
          <Badge
            variant="secondary"
            className="rounded-sm cursor-pointer hover:underline"
            onClick={handleClick}
          >
            {count} product{count !== 1 ? "s" : ""}
          </Badge>
        </div>
      );
    },
  },

  // {
  //   accessorKey: "created_at",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Created" />
  //   ),
  //   cell: ({ row }) => {
  //     return (
  //       <div className="flex w-[150px] items-center">
  //         {format(new Date(row.getValue("createdAt")), "MMM d, yyyy")}
  //       </div>
  //     );
  //   },
  // },
  // {
  //   accessorKey: "updated_at",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Updated" />
  //   ),
  //   cell: ({ row }) => {
  //     return (
  //       <div className="flex w-[150px] items-center">
  //         {format(new Date(row.getValue("updatedAt")), "MMM d, yyyy")}
  //       </div>
  //     );
  //   },
  // },
];
